import React from 'react';
import { PvsInventory, ThomasCampaign } from 'models/interfaces';
import moment from 'moment';
import ThomasCampaignContainer from 'containers/ThomasCampaignContainer';
import PvsVerticalCampaignList from './PvsVerticalCampaignList';

interface PvsInventoryRowItemProps {
  vertical: PvsInventory;
}

interface PvsInventoryRowItemState {
  showCampaigns: boolean;
}

class PvsInventoryRowItem extends React.Component<
  PvsInventoryRowItemProps,
  PvsInventoryRowItemState
> {
  constructor(props: PvsInventoryRowItemProps) {
    super(props);

    this.state = {
      showCampaigns: false
    };
  }
  render() {
    const { vertical } = this.props;
    const { showCampaigns } = this.state;

    const createdDate = moment(new Date(vertical.created_date)).format('MM-DD-YYYY');
    const nextEndDate = moment(new Date(vertical.next_campaign_end_date)).format('MM-DD-YYYY');

    return (
      <React.Fragment>
        <tr>
          <td>{vertical.display_name}</td>
          <td className="align-right">{vertical.vertical_id}</td>
          <td>{vertical.is_active === true ? '' : 'no'}</td>
          <td className="align-right">{createdDate}</td>
          <td className="align-right">{vertical.active_campaign_count}</td>
          <td className="align-right">{nextEndDate}</td>
          <td>
            {vertical.active_campaign_count > 0 && (
              <button
                className="btn btn-outline-secondary"
                onClick={() => this.setState({ showCampaigns: !this.state.showCampaigns })}
              >
                {this.state.showCampaigns ? 'hide' : 'show'}
              </button>
            )}
            {vertical.active_campaign_count == 0 && <span />}
          </td>
        </tr>
        {showCampaigns && (
          <tr className="inventory__campaigns">
            <td colSpan={7}>
              <ThomasCampaignContainer vertical_id={vertical.vertical_id}>
                {({ campaigns }) => <PvsVerticalCampaignList campaigns={campaigns} />}
              </ThomasCampaignContainer>
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  }
}

export default PvsInventoryRowItem;
